import Axios from "axios";
class _UniService {
   async all() {
    return Axios.get("/api/universities/list");
  }
}

export const UniService = new _UniService();
